/* eslint-disable no-plusplus */
/* eslint-disable react/no-danger */
import moment from 'moment';
import React from 'react';
import { TradingMessageTypes } from 'store/modules/monitoring_store/types';
import HighlightedText from 'components/atoms/highlighted_text';
import { Container } from './styles';

interface TradingMessageItemProps {
  tradingMessage: TradingMessageTypes;
  tradingKeywords: Array<string>;
}

const TradingMessageItem = (props: TradingMessageItemProps) => {
  const { tradingMessage, tradingKeywords } = props;

  const regexedKeyword = () => {
    return tradingKeywords.map((keyword) => {
      if (keyword[0] === '*' && keyword[keyword.length - 1] === '*') return keyword;

      if (keyword[0] !== '*' && keyword[keyword.length - 1] === '*') return `*${keyword}`;

      if (keyword[0] === '*' && keyword[keyword.length - 1] !== '*') return `${keyword}*`;

      return `*${keyword}*`;
    });
  };
  return (
    <Container id={`message-${tradingMessage.id}`} className="row mb-3">
      <div className="col-12 col-md-6">
        <div className="d-flex align-items-center">
          <strong>{tradingMessage.message_holder}</strong>
        </div>
      </div>

      <div className="col-12 text-left col-md-6 text-md-right">
        <span className="monitoring-date d-block">
          {moment(tradingMessage.message_time).format('DD/MM/YYYY | k:mm')}
        </span>
      </div>

      <div className="col-12">
        <HighlightedText
          className="p-2 bg-white border rounded"
          termsList={regexedKeyword() || []}
          text={tradingMessage.message_highlight || ''}
        />
      </div>
    </Container>
  );
};

export default TradingMessageItem;
